import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { EquipmentService, UserService,MessageService,FacilityService } from 'src/app/services';
import { EquipmentInfo } from 'src/app/models/equipments/EquipmentInfo'
import { AccessUserInfo, UserDetail, UserLocationFacility } from 'src/app/models';

@Component({
  selector: 'bart-serial-number-merge',
  templateUrl: './serial-number-merge.component.html',
  styleUrls: ['./serial-number-merge.component.scss']
})
export class SerialNumberMergeComponent implements OnInit {

  constructor(private _userService: UserService, private _EquipmentService: EquipmentService, private changeDetector: ChangeDetectorRef,private _messageService:MessageService, private facilityService:FacilityService) { }
  FaceilityMangerColumns: any[];
  selectedserialNumberMergeTarget:any[];
  selectedserialNumberMerge: EquipmentInfo[] = null;
  selectedFindData:any[];
  selectedTargetData:any[];
  public Loding: boolean = false;
  public mergeReason: string = "";
  FaceilityMangerParams = {
    EquipmentIDList: "",
    facilityMasterIdList: "",
    manufacturerId: 0,
    modelId: 0,
    SerialNumber: "",
    UserName: "",
    SearchTerm: null,
    equipmentStatusId: null,
    MachineNickName: null,
    MachineIPAddress: null
  };
  public userId: number = 0;
  public userName: string = '';
  FaceilityMangerFindData: EquipmentInfo[] = [];
  FaceilityMangerTargetData: EquipmentInfo[] = [];
  public targetEquipmentText: string = "";
  public findEquipmentText: string = "";
  public targetPaginator: boolean = false;
  public findPaginator: boolean = false;
  public StatusReasonCodeComment: string = "";
  public targetShowDiv:boolean=false;
  public findShowDiv:boolean=false;
  ngOnInit() {
    let userInfo:UserDetail = AccessUserInfo.getUserInfo();
    this.userId = userInfo.userId;
    this.userName = userInfo.userName;
    this.getUserFailityIdList();
    this.FaceilityMangerColumns = [
      { field: 'ManufacturerName', header: 'Manufacturer' },
      { field: 'modelNumber', header: 'Model' },
      { field: 'EquipmentSerialNumber', header: 'SN/IntID' },
      { field: 'facilityName', header: 'Location' },
      { field: 'EquipmentTypeDescription', header: 'Equip. Type' },
      { field: 'equipmentDescription', header: 'Equipment Descrip' },
    ];
    this.selectedserialNumberMerge = [];
    // this.selectedserialNumberMergeTarget = [];
  }
  private getUserFailityIdList()
  {
     this.Loding = true;
     this.facilityService.getUserLocationFacilities(this.userName,(facilities:UserLocationFacility[])=>
     {
      let userFacilities=facilities.map(x => x.FacilityMasterID).join(", ");
      this.FaceilityMangerParams.facilityMasterIdList=userFacilities;
      this.Loding = false;
     });
  }
  public GetFaceilityManger(type: string) {
    if(this.FaceilityMangerParams.SearchTerm !=null)
    {
      if(this.FaceilityMangerParams.SearchTerm.length<=2)
      {
        this._messageService.showAlertMessage("Search term must be at least three characters");
      }
      else if(this.FaceilityMangerParams.SearchTerm.toUpperCase().split(' ').join('')=="DIALYSIS")
      {
        this._messageService.showAlertMessage("The word 'dialysis' by itself is not a valid search term.");
      }
      else{
        this.Loding = true;
      this.FaceilityMangerParams.UserName = this.userName;
      var GETFACILITYEQUIPMENTMANAGER = this.FaceilityMangerParams;
      this._EquipmentService.getFaceilityManger(JSON.stringify({ GETFACILITYEQUIPMENTMANAGER }))
        .subscribe((Result: any) => {
          if (type == "find") {        
            this.findShowDiv=false;
            this.FaceilityMangerFindData = [];
            this.selectedFindData=[];
            this.FaceilityMangerFindData = Result.facilityEquipment;
           this.FaceilityMangerFindData=this.FaceilityMangerFindData.sort((a, b) => a.EquipmentID- b.EquipmentID);
            if (this.FaceilityMangerFindData.length > 5) {
              this.findPaginator = true;
              this.Loding = false;
            }
            else { this.findPaginator = false; }
          }
          if (type == "target") {
            this.targetShowDiv=false;
            this.FaceilityMangerTargetData = [];
            this.selectedTargetData=[];
            this.FaceilityMangerTargetData = Result.facilityEquipment;
            this.FaceilityMangerTargetData=this.FaceilityMangerTargetData.sort((a, b) => a.EquipmentID- b.EquipmentID);
            if (this.FaceilityMangerTargetData.length > 5) {
              this.targetPaginator = true;
              this.Loding = false;
            }
            else { this.targetPaginator = false; }
          }
          this.Loding = false;
          this.changeDetector.detectChanges();
        },       
          (error) => {
            this.Loding = false;
          }
        );
      }

    }
    else{
      this._messageService.showAlertMessage("Search term must be at least three characters");
    }
 
    
  }
  public findEquiomentData() {
    this.FaceilityMangerParams.SearchTerm = this.findEquipmentText;
    this.GetFaceilityManger("find");
  }
  public targetEquimentData() {
    this.FaceilityMangerParams.SearchTerm = this.targetEquipmentText;
    this.GetFaceilityManger("target");
  }
  public findRowclick(Rowid: number) {
    this.selectedFindData= this.selectedFindData.filter(
      (thing, i, arr) => arr.findIndex(t => t.EquipmentID=== thing.EquipmentID) === i
    );
    this.selectedserialNumberMerge=this.selectedFindData;
    this.findShowDiv=true;
  }
  public targetRowclick(Rowid: number) {
    this.selectedserialNumberMergeTarget = [];   
    this.selectedserialNumberMergeTarget.push(this.selectedTargetData);
    this.targetShowDiv=true;
  }
  public onTargetRowUnselect()
  {
    this.selectedserialNumberMergeTarget = [];
    this.selectedserialNumberMergeTarget.push(this.selectedTargetData);
    this.targetShowDiv=false;
  }
  public onFindRowUnselect()
  {
    this.selectedserialNumberMerge=this.selectedFindData;
    if(this.selectedserialNumberMerge.length==0)
      this.targetShowDiv=false;
  }
  public removeSelectedSerialNumber(EquipmentId: number) {
    this.selectedserialNumberMerge = this.selectedserialNumberMerge.filter(x => x.EquipmentID != EquipmentId);
    this.selectedFindData=this.selectedFindData.filter(x => x.EquipmentID != EquipmentId);
    this.selectedserialNumberMerge=this.selectedFindData;
    if(this.selectedserialNumberMerge.length==0)
    {
      this.findShowDiv=false;
    }
  }
  public mergeEquipment() {

    if (this.selectedserialNumberMerge == null || this.selectedserialNumberMerge.length==0) {
      this._messageService.showAlertMessage("Please select one or more equipment to merge.");

    }
    else if (this.selectedserialNumberMergeTarget == null || this.selectedserialNumberMergeTarget.length==0) {
      this._messageService.showAlertMessage("Please select a serial number to merge into.");

    }
    else if (this.mergeReason == null || this.mergeReason=="") {
      this._messageService.showAlertMessage("Please enter a reason for the equipment merge.");

    }
    else {
      var MERGEEQUIPMENT = {
        MergeIntoID: this.selectedserialNumberMergeTarget[0].EquipmentID,
        MergeFromID: this.selectedserialNumberMerge.map(x => x.EquipmentID).toString(),
        mergeReason: this.mergeReason,
        userid: this.userId
      }
      this._EquipmentService.mergeEquipment(JSON.stringify({ MERGEEQUIPMENT }))
        .subscribe((Result: any) => {
          if(Result && Result.errors)
          {
            this._messageService.showAlertMessage("Equipment merge has failed. " + Result.errors);
          }
          else if (Result.results == null || Result.results == "") 
          {
            this._messageService.showAlertMessage("Equipment has been successfully merged.");
            this.selectedserialNumberMerge = [];
            this.selectedserialNumberMergeTarget = [];
            this.FaceilityMangerTargetData = [];
            this.FaceilityMangerFindData = [];
            this.findEquipmentText = null;
            this.targetEquipmentText = null;
            this.findShowDiv=false;
            this.targetShowDiv=false;
            this.findPaginator = false;
            this.targetPaginator=false;
            this.selectedTargetData=[];
            this.selectedFindData=[];
            this.mergeReason=null;
          }
          else {
            this._messageService.showAlertMessage("Equipment merge has failed. " + Result.results);
          }
        }, 
        (error) => {
          this._messageService.showAlertMessage("Equipment merge has failed. " + error.error.errors);
        }
        );

    }
  }
}
